<template>
  <Page class="detailView">
    <div class="pageContent-title">添加BANNER图</div>
    <div class="detailView-with-actions mt-5">
      <a-form class="flex-form form-label-7 form-base-width" :form="form" :colon="false" labelAlign="left">
        <a-form-item label="位置">
          <a-select
            class="form-control"
            :options="typesMap.position"
            v-decorator="[
              'position',
              {
                rules: [{ required: true, message: '请选择发布位置' }],
                initialValue: 1,
              },
            ]"
            placeholder="请选择"
          ></a-select>
        </a-form-item>
        <a-form-item label="位置">
          <a-select
            class="form-control"
            :options="typesMap.typeList"
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '请选择类型' }],
              },
            ]"
            placeholder="请选择"
          ></a-select>
        </a-form-item>
        <a-form-item label="BANNER图片" v-show="form.getFieldValue('type') == 1">
          <div>
            <PictureCardUpload
              v-decorator="[
                'banner',
                {
                  rules: [{ required: true, message: '请选择' }],
                  initialValue: '',
                },
              ]"
              upload-type="adminVisa"
            ></PictureCardUpload>
          </div>
        </a-form-item>
        <a-form-item label="BANNER视频" v-show="form.getFieldValue('type') == 2">
          <div>
            <videoUpload
              ref="videoUrl"
              v-decorator="[
                'banner',
                {
                  rules: [{ required: true, message: '请选择' }],
                },
              ]"
              upload-oss-type="adminVisa"
              upload-type="video"
              :file-list="videoUrl"
              :max-count="1"
              @onremove="onremove1"
              @onchange="videoChange1"
            ></videoUpload>
          </div>
        </a-form-item>

        <a-form-item label="标题">
          <a-input
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入标题' }],
              },
            ]"
            placeholder="请输入banner标题，为空，前端不显示"
          ></a-input>
        </a-form-item>
        <a-form-item label="跳转链接">
          <a-input
            v-decorator="[
              'link',
              {
                rules: [{ type: 'url', message: '请输入http开头的链接' }],
              },
            ]"
            placeholder="请输入以http开头的链接地址，不能有中文"
          ></a-input>
        </a-form-item>
        <a-form-item label="排序">
          <a-input v-decorator="['sort']" placeholder="请输入"></a-input>
        </a-form-item>
      </a-form>

      <div class="detailView-actions">
        <a-button class="app-btn condition-btns" type="primary" @click="doSave">发布</a-button>
      </div>
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import videoUpload from '@/components/PictureCardListUpload1.vue'
export default {
  components: {
    Page,
    PictureCardUpload,
    videoUpload,
  },
  props: {},
  mixins: [toolMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      videoUrl: [],
      bannerSize: {
        width: 0,
        height: 0,
      },
    }
  },
  computed: {
    typesMap() {
      return {
        position: [
          { value: 1, label: '微信小程序首页顶部' },
          { value: 2, label: '首页标签' },
          { value: 10, label: '我的页面背景' },
          { value: 20, label: '定制游背景-唯一' },
          { value: 30, label: '名片背景图' },
        ],
        typeList: [
          { value: 1, label: '图片' },
          { value: 2, label: '视频' },
          { value: 10, label: '内部文章' },
          { value: 20, label: '外部链接' },
        ],
      }
    },
  },
  methods: {
    onremove1() {
      this.videoUrl = []
      this.form.setFieldsValues({
        banner: '',
      })
    },
    videoChange1(obj) {
      console.log('videoChange1', obj)
      this.videoUrl = [obj]
      this.form.setFieldsValue({
        banner: obj,
      })
      this.$refs.videoUrl.upLoading()
      console.log('getFieldsValue', this.form.getFieldsValue())
    },
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          if (this.$route.query.id) {
            params.articleId = this.$route.query.id
          } else {
            delete params.articleId
          }
          params.status = 10
          try {
            await this.$axios.post('/auxiliary/admin/article/ad', {
              ...params,
            })
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async loadById(id) {
      const res = await this.$axios.get(`/auxiliary/admin/article/${id}`)
      if (res.data.type == 2) {
        this.videoUrl = [res.data.banner]
      }
      const dataInfo = res.data
      this.safeSetFieldsValue$t(this.form, { ...dataInfo })
    },
  },
  mounted() {
    const id = this.$route.query.id
    if (id) {
      this.loadById(id)
    }
  },
}
</script>
<style scoped lang="less"></style>
